<!--
 * @Author: baiwei
 * @Date: 2020-02-26 09:58:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-23 17:48:20
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div class="module">
        <helpinfo :helpData="helpData">
            <div slot="slotR">
                <span>
                    <div class="helpInfo-right">
                        <Button type="primary"
                                @click="viewcontract"
                                :disabled="viewButton"
                                v-if="this.hasPermission('CC0601')"
                                slot="tootipL">
                            {{$t('查看合同')}}
                        </Button>
                    </div>
                    <div class="helpInfo-right"
                         @click="$router.go(-1)">
                        <Icon type="ios-arrow-dropleft"
                              size="16" />
                        <span>{{$t('返回')}}</span>
                    </div>
                </span>
            </div>
        </helpinfo>
        <!-- <Tabs v-model="curTab"
              class="module-container"
              :animated="false">
            <TabPane label="详情"
                     name="info">
                <contractinfo v-if="curTab === 'info'"
                              :contractId="contractId" />
            </TabPane>
        </Tabs> -->
        <div style="padding: 15px;">
            <DetailInfo title="基本信息">
                <Item label="合同名称">
                    <span :title="info.contractTitle">{{info.contractTitle}}</span>
                </Item>
                <Item label="合同创建时间"
                      :value="info.createdDt" />
                <Item label="合同状态"
                      :value="$t(statusName[info.contractStatus])">
                    <statusview v-if="info.contractStatus"
                                :state="info.contractStatus"
                                :stateName="$t(statusName[info.contractStatus])"
                                style="margin-top: 7px;"></statusview>
                </Item>
                <Item label="合同ID"
                      :value="info.contractId" />
                <Item :label="$t('合同类型')"
                      :value="$t(typeNames[info.discountScope]) || info.discountScope" />
                <template v-if="info.discountScope === 'normal'">
                    <Item label="合同总金额">
                        <span class="balance-color">{{$money(info.amount)}}</span>
                    </Item>
                    <Item label="信用余额">
                        <span class="balance-color">{{$money(info.credit)}}</span>
                    </Item>
                    <Item :label="$t('合同签订时间')"
                          :value="info.signedTime || '--'" />
                    <Item label="合同开始时间"
                          :value="info.startTime || '--'" />
                    <Item label="合同结束时间"
                          :value="info.endTime || '--'" />
                    <Item label="合同文件"
                          style="width:100%;">
                        <div>
                            <template v-for="(item,index) in info.contractFiles">
                                <!-- @click="download(item)" -->
                                <p class="rc-ellipsis"
                                   :key="index"
                                   style="color: #333;"
                                   :title="item.fileName">{{item.fileName || '--'}}</p>
                            </template>
                        </div>
                    </Item>
                    <Item :label="$t('备注')"
                          style="width:100%">
                        <span class="rc-ellipsis"
                              :title="info.decription">{{info.decription || '--'}}</span>
                    </Item>
                    <Item v-for="(item, i) in attachList"
                          :key="i"
                          :label="Object.keys(item)[0]">
                        <span class="rc-ellipsis"
                              :title="Object.values(item)[0] || '--'">{{Object.values(item)[0] || '--'}}</span>
                    </Item>
                </template>
                <!-- 扩容、续费 -->
                <template v-else>
                    <Item :label="$t('合同签订时间')"
                          :value="info.signedTime || '--'" />
                    <Item v-if="info.discountScope === 'hpc_renew'"
                          :label="$t('扩容合同')">
                        <a @click="toContracts">{{info.expansionTitle || '--'}}</a>
                    </Item>
                    <Item :label="$t(info.discountScope==='hpc_open'?'资源扩容时长':'资源续订时长')"
                          :value="info.contractMonth" />
                    <Item v-if="info.discountScope === 'hpc_renew'"
                          :label="$t('付款状态')"
                          :value="$t(info.payStatus?'已付款':'未付款')" />
                    <Item :label="$t('资源池规模')"
                          :value="$t(resourcePoolTypeNames[info.resourcePoolType])" />
                    <Item style="width: 100%; height: 0; overflow:hidden;" />
                    <Item :label="$t('计算节点')"
                          :value="info.agentNumberOpen?info.agentNumberOpen + $t('个'):'--'" />
                    <Item :label="$t('价格')"
                          style="width: 66.6%">
                        <span style="color: #ff6a01;margin-right:3px;">{{info.agentPrice || '--'}}</span> {{$t('元')}} / {{$t('每节点')}}
                    </Item>
                    <Item :label="$t('登录节点')"
                          :value="info.cliNumberOpen?info.cliNumberOpen + $t('个'):'--'" />
                    <Item :label="$t('价格')"
                          style="width: 66.6%">
                        <span style="color: #ff6a01;margin-right:3px;">{{info.cliPrice || '--'}}</span> {{$t('元')}} / {{$t('每节点')}}
                    </Item>
                    <Item :label="$t('VNC可视化节点')"
                          :value="info.vncNumberOpen?info.vncNumberOpen + $t('个'):'--'" />
                    <Item :label="$t('价格')"
                          style="width: 66.6%">
                        <span style="color: #ff6a01;margin-right:3px;">{{info.vncPrice || '--'}}</span> {{$t('元')}} / {{$t('每节点')}}
                    </Item>
                    <Item :label="$t('合同文件')"
                          style="width:100%;">
                        <div>
                            <template v-for="(item,index) in info.contractFiles">
                                <!-- @click="download(item)" -->
                                <p class="rc-ellipsis"
                                   :key="index"
                                   style="color: #333;"
                                   :title="item.fileName">{{item.fileName || '--'}}</p>
                            </template>
                        </div>
                    </Item>
                </template>
            </DetailInfo>
            <div v-if="info.policy && info.policy.length"
                 class="detailInfo-pack info-pack discount-info">
                <div class="title"
                     style="margin-bottom: 10px;">{{$t('折扣信息')}}</div>
                <ul v-for="(item, index) in info.policy"
                    :key="index"
                    style="padding: 0">
                    <li><span class="label">{{$t('云类型')}}</span>：{{item.envVO.map(env=>$t(env.cloudEnvName)).join(', ')}}</li>
                    <li><span class="label">{{$t('适用产品')}}</span>：{{item.productVO.map(env=>$t(env.productName) || env.productType).join(', ')}}</li>
                    <li><span class="label">{{$t('折扣系数')}}</span>：{{item.discountRatio}}</li>
                </ul>
            </div>
        </div>
        <viewcontract ref="viewcontract"></viewcontract>
    </div>
</template>
<script>
import helpinfo from '@/views/components/basic/helpinfo'
import { DetailInfo, Item } from '@c/basic/rcdetailinfo'
import { downloadFile } from '@/service/utils'
import viewcontract from '@/views/console/contract/components/viewcontract'
import API from '@/service/api.js'
export default {
    name: 'contracdetail',
    components: {
        helpinfo,
        DetailInfo,
        Item,
        viewcontract
    },
    data () {
        const contractId = this.$route.params.id
        return {
            helpData: {
                modelName: this.$t('合同详情') + ' - ' + contractId
                // showBack: true
            },
            contractId: contractId,
            info: {},
            attachList: [], // 附加属性的列表
            statusName: {
                unused: this.$t('未使用'),
                approving: this.$t('待审核'),
                audit_rejected: this.$t('审核不通过'),
                audit_executing: this.$t('执行中'),
                terminated: this.$t('合同终止'),
                expired: this.$t('合同过期')
            },
            typeNames: {
                normal: '折扣合同',
                hpc_open: '扩容合同',
                hpc_renew: '续订合同'
            },
            resourcePoolTypeNames: {
                small: '小规模专属资源池',
                middle: '中规模专属资源池',
                big: '大规模专属资源池'
            },
            viewButton: false
        }
    },
    created () {
        this.getDetail()
    },
    methods: {
        getDetail () {
            this.contractId = this.$route.params.id
            this.info = {}
            this.axios.get(`${this.urlFormat(API.CONTRACT)}/${this.contractId}`).then(res => {
                this.info = res || {}
                this.viewButton = !this.info.contractId // 判断是否返回值 没返回禁用
                this.attachList = res.contractAdditional ? JSON.parse(res.contractAdditional) : []
            })
        },
        download () {
            downloadFile(this.info.contractFile, this.info.contractFileName)
        },
        viewcontract () {
            if (!this.viewButton) {
                this.$refs.viewcontract.open(this.info)
            }
        },
        toContracts () {
            this.info.contractSid && this.$router.push({ path: `/mgt/contracts/detail/${this.info.contractSid}` })
        }
    },
    watch: {
        $route: 'getDetail'
    }
}
</script>
<style lang="less">
.detailInfo-pack.discount-info > ul li .label {
    width: 100px;
    display: inline-block;
}
.helpInfo-right {
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
}
</style>
